module.exports = __webpack_public_path__ + "static/media/logo.2ccf07a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Projects/Tommy/assets/logo.png
// module id = 196
// module chunks = 0